// apiConfig.js
const API_BASE_URL = "https://720degrees.ai/720portaladmin/api";


// Declare the language variable
const LANGUAGE = localStorage.getItem('lang')? "lang_"+localStorage.getItem('lang'): "lang_en" ;

const API_URLS = {
  baseUrl: `https://720degrees.ai/720portaladmin/public/`,
  baseFrontUrl: `https://720degrees.ai`,
  defaultDirectory: ``,
  defaultLang: `${LANGUAGE}`,
  getLang: `${API_BASE_URL}/getLanguage`,
  getMenu: `${API_BASE_URL}/menu-data?language=${LANGUAGE}`,
  getHomePage: `${API_BASE_URL}/page-metadata/15/${LANGUAGE}`,
  postContact: `${API_BASE_URL}/post-contact`,
  getFooter: `${API_BASE_URL}/getfooter/${LANGUAGE}`,
  getFooterLink: `${API_BASE_URL}/getfooterlink/${LANGUAGE}`,
  getAllDetails: `${API_BASE_URL}`,
  getValuesPurpose: `${API_BASE_URL}/who-we-are-posts/2`,
  //getLeadership: `${API_BASE_URL}/gettestimonial/${LANGUAGE}`,
  getContact: `${API_BASE_URL}/page-metadata/27/${LANGUAGE}`,
  // getFaq: `${API_BASE_URL}/page-metadata/28/${LANGUAGE}`,
  postCareerFormSubmit: `${API_BASE_URL}/career-page-form-submit`,
  getSearchData: `${API_BASE_URL}/search`,

};

export default API_URLS;
